<!-- eslint-disable max-len -->
<template>
  <div
    id="form-search-popover"
    class="container-app-search">

    <!-- HEADER SECTION -->
    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header"
      style="padding-bottom: 0 !important; padding-top: 15px !important; height: 110px">
      <div class="d-flex apps">
        <img
          class="back-to-list-apps"
          src="@/assets/icon/arrow-left.svg"
          @click="$router.push('/access-application')"
        >
        <img
          v-if="apps_detail"
          :src="apps_detail.icon"
          class="m__r--5"
          width="25">
        <div class="title-apps">
          {{ apps_detail ? apps_detail.name : '' }}
        </div>
      </div>
      <div class="d-flex m__t--39">
        <div
          :class="{'tab-experience-manager-active' : tabSelected === 'privileges'}"
          class="tab-experience-manager m__r--35"
          @click="tabSelected = 'privileges'">
          PRIVILEGES
        </div>
        <div
          :class="{'tab-experience-manager-active' : tabSelected === 'security'}"
          class="tab-experience-manager m__r--35"
          @click="tabSelected = 'security'">
          SECURITY
        </div>
        <div
          :class="{'tab-experience-manager-active' : tabSelected === 'maintenance'}"
          class="tab-experience-manager"
          @click="tabSelected = 'maintenance'">
          MAINTENANCE
        </div>
      </div>
    </div>

    <!-- CONTENT SECTION -->
    <div
      v-if="tabSelected === 'privileges'"
      class="studio-page-content">
      <jAccessApplicationTabPrivilege />
    </div>

    <!-- Tab Security -->
    <div
      v-if="tabSelected === 'security'"
      class="studio-page-content">
      <jAccessApplicationTabSecurity />
    </div>

    <!-- Tab Maintenance -->
    <div
      v-if="tabSelected === 'maintenance'"
      class="studio-page-content">
      <jAccessApplicationTabMaintenance />
    </div>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-unused-vars, no-console */
import { mapState } from 'vuex';
import jAccessApplicationTabSecurity from '@/views/access/tab/jAccessApplicationTabSecurity';
import jAccessApplicationTabPrivilege from '@/views/access/tab/jAccessApplicationTabPrivilege';
import jAccessApplicationTabMaintenance from '@/views/access/tab/jAccessApplicationTabMaintenance';

export default {
  components: {
    jAccessApplicationTabSecurity,
    jAccessApplicationTabPrivilege,
    jAccessApplicationTabMaintenance,
  },

  data() {
    return {
      tabSelected: 'privileges',
      apps_detail: null,
    };
  },

  computed: {
    ...mapState('jStoreSetting', ['application_detail', 'is_sidebar_minimized']),
  },

  watch: {
    application_detail(val) {
      this.apps_detail = {
        id: val.id,
        name: val.name,
        icon: val.icon,
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/access/jAccessApplicationDetail.vue